import React from "react";
import PropTypes from "prop-types";
import { Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap";
import styled from "styled-components";
import CorespondentModal from "./../Modals/CorespondentModal";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactSelect from "react-select";
import LegalEntityModal from "../Modals/LegalEntityModal";
import SignatureModal from "../Modals/SignatureModal";

const CorrespondentBanks = props => {
  const [toggleCorespondent, setToggleCorespondent] = React.useState(false);
  const [toggleLegalEntity, setToggleLegalEntity] = React.useState(false);
  const [toggleSignature, setToggleSignature] = React.useState(false);
  const [legalEntity, setLegalEntity] = React.useState(null);
  const [editData, setEditData] = React.useState(null);
  const [correspondentBank, setCorespondentBank] = React.useState(null);
  const [base64Image, setBase64Image] = React.useState("");
  const [deleteAlert, setDeleteAlert] = React.useState({
    status: false,
  });

  React.useEffect(() => {
    if (props.data) {
      setCorespondentBank(props.data);
    } else {
      setCorespondentBank(null);
    }

    if (props.bankDetails?.signature) {
      setBase64Image(props.bankDetails?.signature)
      // handleFetchImage(props.bankDetails?.signature);
    }

    if (props.bankDetails.default_legal_entity) {
      let idx = props.legal_entity_data.results.findIndex(
        i => i.id === props.bankDetails.default_legal_entity
      );
      if (idx >= 0) {
        setLegalEntity({
          label: props.legal_entity_data.results[idx]?.counterparty_name,
          value: props.legal_entity_data.results[idx]?.id,
        });
      }
    }

    return () => {
      setBase64Image("")
    };
  }, [props.data, props.bankDetails]);

  const handleFetchImage = img => {
    const fetchImage = async () => {
      try {
        const response = await fetch(img);
        const blob = await response.blob();

        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          setBase64Image(base64String);
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };

    fetchImage();
  };

  const toggleViewAddCorespondent = () => {
    setToggleCorespondent(!toggleCorespondent);
    setEditData(null);
  };

  const toggleViewAddLegalEntity = () => {
    setToggleLegalEntity(!toggleLegalEntity);
    setEditData(null);
  };

  const toggleViewAddSignature = () => {
    setToggleSignature(!toggleSignature);
    setEditData(null)
  }

  const onClickDelete = (title, id, user) => {
    setDeleteAlert({
      status: true,
      title: `Delete "${title}"!`,
      onConfirm: () => {
        toggleViewAddCorespondent();
        props.deleteBankCorespondent(id, user);
        setDeleteAlert({
          status: false,
        });
      },
    });
  };

  const onClickEditCorespondent = (e, row, type) => {
    if (props.permissions["view_bankcorrespondentmodel"]) {
      setToggleCorespondent(!toggleCorespondent);
      setEditData(type === "edit" ? row : null);
    }
  };

  const onClickEditLegalEntity = () => {
    setToggleLegalEntity(!toggleCorespondent);
    setEditData(legalEntity);
  };

  const onClickEditSignature = () => {
    setToggleSignature(!toggleCorespondent);
    setEditData(props.bankDetails);
  }

  const handleCorespondent = () => {
    if (correspondentBank !== null) {
      onClickEditCorespondent("", correspondentBank, "edit");
    } else {
      onClickEditCorespondent("", correspondentBank);
    }
  };

  return (
    <MainBlock>
      {toggleCorespondent && (
        <CorespondentModal
          isOpen={toggleCorespondent}
          toggle={toggleViewAddCorespondent}
          editData={editData}
          userId={props.userId}
          addBankCorespondent={props.addBankCorespondent}
          updateBankCorespondent={props.updateBankCorespondent}
          permissions={props.permissions}
          onClickDelete={onClickDelete}
          bankDetails={props.bankDetails}
        />
      )}

      {toggleLegalEntity && (
        <LegalEntityModal
          isOpen={toggleLegalEntity}
          toggle={toggleViewAddLegalEntity}
          editData={editData}
          options={props.legal_entity_data.results}
          userId={props.userId}
          updateBankDetails={props.updateBankDetails}
          permissions={props.permissions}
          bankDetails={props.bankDetails}
        />
      )}

      {toggleSignature && (
        <SignatureModal
          isOpen={toggleSignature}
          toggle={toggleViewAddSignature}
          editData={editData}
          userId={props.userId}
          updateBankDetails={props.updateBankDetails}
          permissions={props.permissions}
          bankDetails={props.bankDetails}
        />
      )}

      {deleteAlert.status && (
        <SweetAlert
          showCancel
          confirmBtnText="Delete"
          cancelBtnText="Cancel"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle=""
          title={deleteAlert.title}
          onCancel={() => setDeleteAlert(false)}
          onConfirm={deleteAlert.onConfirm}
        >
          <p>Are you sure want to delete this corespondent bank?</p>
        </SweetAlert>
      )}

      <Card className="overflow-hidden" style={{ margin: 0 }}>
        <CardBody>
          {props.legal_entity_loading && (
            <LoaderStyled className="table-loader">
              <div className="spinner-border text-primary m-1" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </LoaderStyled>
          )}
          <Row
            style={{
              userSelect: "none",
              opacity: props.legal_entity_loading ? "0.5" : "1",
            }}
            className="mt-2"
          >
            <Col md={12}>
              <div
                className="d-flex"
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  <CardTitle className="mb-4 h4">
                    Default legal entity
                  </CardTitle>
                </div>
                <div>
                  {props.permissions["change_bankdetailsmodel"] && (
                    <EditDataStyled
                      className="bx bx-pencil font-size-18 mw-2 float-end"
                      onClick={() => onClickEditLegalEntity()}
                    />
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row
            style={{
              userSelect: "none",
              opacity: props.loading_details ? "0.5" : "1",
            }}
          >
            <div className="table-responsive">
              <Table className="table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Counterparty name :</th>
                    <td>
                      {legalEntity?.label ? legalEntity?.label : "Not found"}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Row>
          <Row
            style={{
              userSelect: "none",
              opacity: props.legal_entity_loading ? "0.5" : "1",
            }}
            className="mt-2"
          >
            <Col md={12}>
              <div
                className="d-flex mt-3"
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  <CardTitle className="mb-4 h4">
                    Signature
                  </CardTitle>
                </div>
                <div>
                  {props.permissions["change_bankdetailsmodel"] && (
                    <EditDataStyled
                      className="bx bx-pencil font-size-18 mw-2 float-end"
                      onClick={() => onClickEditSignature()}
                    />
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row
            style={{
              userSelect: "none",
              opacity: props.loading_details ? "0.5" : "1",
            }}
          >
            <div className="table-responsive">
              <Table className="table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Signature:</th>
                    <td className="d-flex justify-content-center">
                      {props.bankDetails?.signature ? (<img
                        id="signature__preview_image"
                        className="signature__preview_image"
                        src={base64Image?.preview
                          ? base64Image?.preview
                          : base64Image}
                        alt="signature__preview_image"
                      />) : "Not found"}
                      {/* {legalEntity?.label ? legalEntity?.label : "Not found"} */}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Row>
        </CardBody>
      </Card>
      <Card className="overflow-hidden" style={{ margin: 0, minHeight: 282 }}>
        <CardBody>
          {props.loading_corespondent && (
            <LoaderStyled className="table-loader">
              <div className="spinner-border text-primary m-1" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </LoaderStyled>
          )}
          <Row
            style={{
              userSelect: "none",
              opacity: props.legal_entity_loading ? "0.5" : "1",
            }}
            className="mt-2"
          >
            <Col md={12}>
              <div
                className="d-flex"
                style={{ justifyContent: "space-between" }}
              >
                <div>
                  <CardTitle className="mb-4 h4">Bank correspondent</CardTitle>
                </div>
                <div>
                  {props.permissions["change_bankdetailsmodel"] && (
                    <EditDataStyled
                      className="bx bx-pencil font-size-18 mw-2 float-end"
                      onClick={() => handleCorespondent()}
                    />
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row
            style={{
              userSelect: "none",
              opacity: props.legal_entity_loading ? "0.5" : "1",
            }}
          >
            <div className="table-responsive">
              <Table className="table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Correspondent account :</th>
                    <td>
                      {correspondentBank?.account_in_the_correspondent_bank
                        ? correspondentBank.account_in_the_correspondent_bank
                        : "Not found"}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Correspondent bank :</th>
                    <td>
                      {correspondentBank?.correspondent_bank
                        ? correspondentBank?.correspondent_bank
                        : "Not found"}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Address :</th>
                    <td>
                      {correspondentBank?.address
                        ? correspondentBank?.address
                        : "Not found"}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">SWIFT :</th>
                    <td>
                      {correspondentBank?.swift_code_of_the_correspondent_bank
                        ? correspondentBank?.swift_code_of_the_correspondent_bank
                        : "Not found"}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Row>
        </CardBody>
      </Card>
    </MainBlock>
  );
};

const MainBlock = styled.div`
  .signature__preview_image { 
    width: 41px;
    min-width: 41px;
  }
`
const LoaderStyled = styled.div`
  opacity: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const EditDataStyled = styled.i`
  cursor: pointer;
  transition-duration: 0.5s;
  &:hover {
    color: #2684ff;
    transition-duration: 0.5s;
  }
`;

CorrespondentBanks.propTypes = {
  data: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
  permissions: PropTypes.any,
  getBankCorespondents: PropTypes.func.isRequired,
  deleteBankCorespondent: PropTypes.func.isRequired,
  updateBankCorespondent: PropTypes.func.isRequired,
  addBankCorespondent: PropTypes.func.isRequired,
  loading_corespondent: PropTypes.bool.isRequired,
  legal_entity_data: PropTypes.object.isRequired,
  legal_entity_loading: PropTypes.bool.isRequired,
  updateBankDetails: PropTypes.func.isRequired,
  bankDetails: PropTypes.object.isRequired,
  loading_details: PropTypes.bool.isRequired,
};

export default CorrespondentBanks;
